// extracted by mini-css-extract-plugin
export default {"root":"Footer-root-c92fa28a48db4539ff822d3b1f0bffc8"};